import {Component, ElementRef} from '@angular/core';
import { environment } from '../../../environments/environment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {DetalleJornadaDTO} from "../../../dtos/detalleJornada.dto";
import {JornadaDTO} from "../../../dtos/jornada.dto";
import {ApiService} from "../../services/api.service";
import {JornadaService} from "../../services/jornada.service";
import {EventService} from "../../services/event.service";
import {GetDetalleJornadaResponseDTO} from "../../../dtos/response/getDetalleJornada.response.dto";
import {GeneralResponseDTO} from "../../../dtos/response/general.response.dto";
import {AppMessage} from "../../app.message";
import {TimepickerModule} from "ngx-bootstrap/timepicker";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import moment from "moment/moment";
// import 'moment/locale/es';
import {PutActualizarHoraJornadaResquestDTO} from "../../../dtos/request/putActualizarHoraJornada.resquest.dto";
import {HttpErrorResponse} from "@angular/common/http";
import {EstadosService} from "../../services/estados.service";
import {NgIf} from "@angular/common";
import {ToastrService} from "ngx-toastr";
import {BsDatepickerModule} from "ngx-bootstrap/datepicker";
import {UserService} from "../../services/user.service";
moment.locale('es');

@Component({
  selector: 'app-modal-editar-jornada',
  standalone: true,
  imports: [
    TimepickerModule,
    FormsModule,
    ReactiveFormsModule,
    NgIf,
    BsDatepickerModule
  ],
  templateUrl: './modal-editar-jornada.component.html',
  styleUrl: './modal-editar-jornada.component.scss'
})
export class ModalEditarJornadaComponent {

  public detalleJornada: DetalleJornadaDTO;
  public jornada: JornadaDTO;
  public formHoras: FormGroup;
  public banderaDiaSiguiente: boolean = false;
  public enviando: boolean = false;
  public diaInicioFormateado: string;

  constructor(private modalRef: BsModalRef, private apiService: ApiService, private jornadaService: JornadaService,
              private eventService: EventService, private formBuilder: FormBuilder, private el: ElementRef,
              public estadosService: EstadosService, private toastr: ToastrService, private userService: UserService) {
    this.jornada = this.jornadaService.getJornadaSeleccionada();
    this.getDetalleJornada();
    this.initForm();
    this.eventService.subscribe('JORNADA_ACTUALIZADA_MQTT_EVENT', (jornada: JornadaDTO) => {
      if(jornada.uuid == this.jornada.uuid) {
        this.jornada = jornada;
        this.detalleJornada = jornada;
      }
    })
  }

  initForm() {
    this.formHoras = this.formBuilder.group({
      horaInicio: [moment.utc(this.jornada.fechaInicioPlanificado).local().format('HH:mm'), [Validators.required]],
      horaTermino: [moment.utc(this.jornada.fechaTerminoPlanficiado).local().format('HH:mm'), [Validators.required]],
      diaTermino: [moment.utc(this.jornada.fechaTerminoPlanficiado).local().toDate(), [Validators.required]]
    });
    this.diaInicioFormateado = moment.utc(this.jornada.fechaInicioPlanificado).local().format('DD-MM-YYYY');
    this.verificaHorasDiaSiguiente();
  }

  close() {
    this.modalRef.hide();
  }

  tienePermisoEditarJornada(): boolean {
    return this.userService.tienePermiso('JORNADA_CAMBIAR_HORA');
  }

  getDetalleJornada(init: boolean = false) {
    this.apiService.getDetalleJornada(this.jornada.uuid)
      .subscribe((resp) => this.getDetalleJornadaSuccess(resp), (error) => this.getDetalleJornadaError(error));
  }

  getDetalleJornadaSuccess(getDetalleJornadaResponseDTO: GetDetalleJornadaResponseDTO) {
    console.log('exito get detalle jornada', getDetalleJornadaResponseDTO);
    this.detalleJornada = getDetalleJornadaResponseDTO.data;
  }

  getDetalleJornadaError(error: HttpErrorResponse) {
    console.log('error get detalle jornada', error);
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_DETALLE_JORNADA_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  verificaHorasDiaSiguiente(event: any = null){
    if(!this.formHoras.valid) {
      this.banderaDiaSiguiente = false;
      return;
    }

    const [hInicio, mInicio] = this.formHoras.get('horaInicio').value.split(':');
    const [hTermino, mTermino] = this.formHoras.get('horaTermino').value.split(':');

    const fechaInicio = moment.utc(this.jornada.fechaInicioPlanificado)
      .local()
      .set({ hour: +hInicio, minute: +mInicio });

    const fechaTermino = moment.utc(this.jornada.fechaInicioPlanificado)
      .local()
      .set({ hour: +hTermino, minute: +mTermino });

    if(fechaTermino.isBefore(fechaInicio)) {
      this.banderaDiaSiguiente = true;
    } else
      this.banderaDiaSiguiente = false;
  }

  putActualizarHoraJornada() {
    if(this.formHoras.invalid) {
      this.formHoras.touched;
      //alert('Campos invalidos de Hora por favor revisar');
      this.toastr.warning('Campos invalidos de Hora por favor revisar', 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
      return;
    }

    this.verificaHorasDiaSiguiente();

    let putActualizarHoraJornadaResquestDTO = new PutActualizarHoraJornadaResquestDTO();
    const [hInicio, mInicio] = this.formHoras.get('horaInicio').value.split(':');
    const [hTermino, mTermino] = this.formHoras.get('horaTermino').value.split(':');

    putActualizarHoraJornadaResquestDTO.fechaInicio = moment.utc(this.jornada.fechaInicioPlanificado)
      .local()
      .set({ hour: +hInicio, minute: +mInicio, second: 0 })
      .utc()
      .format();

    putActualizarHoraJornadaResquestDTO.fechaTermino = moment(this.formHoras.get('diaTermino').value)
      .set({ hour: +hTermino, minute: +mTermino, second: 0 })
      .utc()
      .format();

    this.enviando = true;
    this.apiService.putActualizarHoraJornada(this.jornada.uuid, putActualizarHoraJornadaResquestDTO)
      .subscribe(res => this.putActualizarHoraJornadaSuccess(res), error => this.putActualizarHoraJornadaError(error));
  }

  putActualizarHoraJornadaSuccess(generalResponseDTO: GeneralResponseDTO) {
    console.log('put editar hora joranda success', generalResponseDTO);
    //alert(generalResponseDTO.msg);
    //this.alertService.presentAlertaInfo(generalResponseDTO.msg);
    this.toastr.success(generalResponseDTO.msg, 'Éxito', { timeOut: environment.toastSuccessTimeout, extendedTimeOut: environment.toastSuccessTimeout, closeButton: true, tapToDismiss: false });
    this.eventService.publish('CAMBIO_HORA_JORNADA_SUCCESS');
    this.enviando = false;
    this.close();
  }

  putActualizarHoraJornadaError(error: HttpErrorResponse) {
    console.log('put editar hora jornada error', error);
    this.enviando = false;
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_PUT_EDITAR_HORA_JORNADA_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

}
